import styled from "styled-components";
import { COLOUR_CONSTANT } from "../../../utils/contants";

export const PlannerTotalsStyled = styled.div`
  .heading {
    display: flex;
    padding-left: 16px;
    justify-content: space-between;
    h5 {
      color: white;
    }
  }

  h5 {
    color: white;
  }
  .MuiAccordionSummary-root {
    background-color: ${COLOUR_CONSTANT.theme.background.dark} !important;
    .MuiAccordionSummary-expandIconWrapper svg {
      color: white;
    }
  }

  .totals-body {
    pointer-events: ${(props) => (props.isGeneralUser ? "none" : "auto")};
    overflow-x: clip;
    width: 100%;
  }

  .fields {
    padding: 16px;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    column-gap: 16px;
  }

  .divider {
    margin: 0 16px 0 16px;
    .div-style {
      width: 100%;
      background: ${COLOUR_CONSTANT.theme.purple.medium};
    }
  }
`;
